// extracted by mini-css-extract-plugin
module.exports = {"root":"IconCancel_root__ZM_mO"};